module.exports = __webpack_public_path__ + "files/2473dbfd3a2307d89ba4052d55e9b223.png";